import request from "@/utils/request";

export function getStationDataApi(params) {
  return request({
    url: "?c=pp&a=station&do=getall",
    method: "get",
    params
  });
}

export function getStationListApi(params) {
  return request({
    url: "?c=pp&a=station&do=list",
    method: "get",
    params
  });
}

export function getStationApi(params) {
  return request({
    url: "?c=pp&a=station&do=get",
    method: "get",
    params
  });
}

export function postStationApi(data) {
  return request({
    url: "?c=pp&a=station&do=post",
    method: "post",
    data
  });
}

export function stationDelApi(data) {
  return request({
    url: "?c=pp&a=station&do=del",
    method: "post",
    data
  });
}

export function importStationApi(data) {
  return request({
    url: "?c=pp&a=station&do=import",
    method: "post",
    data
  });
}

export function exportStationApi(params) {
  return request({
    url: "?c=pp&a=station&do=export",
    method: "get",
    params
  });
}

export function precreateNoApi(data) {
  return request({
    url: "?c=pp&a=station&do=precreate",
    method: "post",
    data
  });
}

export function unbindApi(data) {
  return request({
    url: "?c=pp&a=station&do=unbind",
    method: "post",
    data
  });
}

export function getStationUserApi(params) {
  return request({
    url: "?c=pp&a=station&do=user-getall",
    method: "get",
    params
  });
}

export function getStationWorkorderStatApi(params) {
  return request({
    url: "?c=pp&a=station&do=workorder-stat",
    method: "get",
    params
  });
}

export function getStationWorkorderListApi(params) {
  return request({
    url: "?c=pp&a=station&do=workorder-getall",
    method: "get",
    params
  });
}
